import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExternalSelectorModule } from '../external-selector/external-selector.module';
import { ContraentePickerComponent } from './contraente-picker.component';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { ContraenteTypeSelectorComponent } from './contraente-type-selector/contraente-type-selector.component';

const entityPickers = [
  ContraentePickerComponent,
  ContraenteTypeSelectorComponent,
];

@NgModule({
  declarations: entityPickers,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ExternalSelectorModule,
    CustomMaterialModule,
  ],
  exports: entityPickers,
})
export class ContraentePickerModule { }
